export interface Feature {
    icon: string;
    title: string;
    description: string;
  }
  
  export const features: Feature[] = [
    {
      icon: 'shield',
      title: 'Ownership Protection',
      description: 'Inaudible frequency fingerprints ensure your music is protected from illegal distribution'
    },
    {
      icon: 'dollar',
      title: 'Instant Verification',
      description: 'Smart contract-based ownership with transparent blockchain verification'
    },
    {
      icon: 'music',
      title: 'High-Quality Downloads',
      description: 'Premium audio files with unique watermarks for verified owners only'
    },
    {
      icon: 'lock',
      title: 'Artist Communities',
      description: 'Connect with exclusive fan communities and get early access to new releases'
    }
  ];